import msalInstance from '@core/auth/msalInstance';

const getCurrentUserAccount = () => msalInstance.getActiveAccount();

export default getCurrentUserAccount;
